import React, { useEffect } from 'react'
import { Select } from 'antd'
import { useListGroupsQuery } from '../redux/Api/UserManagment/uMGroupsApiSlice'
import { toast } from 'react-toastify'

const GroupsDropdown = ({ onChange, onBlur, value, multi = true }) => {
    const { data: groups, isLoading, error } = useListGroupsQuery({
        page: '*',
        ordering: 'name',
        fields: 'id,name'
    })
    let options = []
    if (groups) {
        options = groups?.results?.map((item) => {
            return {
                label: item.name,
                value: item.id
            }
        })
    }


    useEffect(() => {
        if (error?.data) {
            const errorMessages = Object.values(error.data).flat()
            errorMessages.forEach(message => {
                toast.error(message)
            })
        }
    }, [error])

    return (
        <div className=" mb-3">
            <label className="" >Groups</label>
            <br />
            <Select
                mode={multi ? "multiple" : ""}
                allowClear
                style={{
                    width: '100%',
                }}
                optionFilterProp="label"
                loading={isLoading}
                placeholder="Please select"
                onBlur={onBlur}
                value={value}
                onChange={(e) => onChange("groups", e)}
                options={options}
            />
        </div>
    )
}

export default GroupsDropdown